import baseEditForm from 'formiojs/components/_classes/component/Component.form'

import omitFormioTabs, { omitTabsBaseConfig } from 'utils/omit-formio-tabs'

const selectBaseEditForm = (...extend) =>
    baseEditForm(
        [
            {
                key: 'display',
                components: [
                    {
                        key: 'placeholder',
                        ignore: true,
                    },
                ],
            },
            {
                key: 'data',
                components: [
                    {
                        type: 'textfield',
                        input: true,
                        label: 'Display Custom Value',
                        weight: 12,
                        key: 'displayValue',
                        placeholder: 'item.label',
                        tooltip:
                            'Path to a field that will be displayed in the HTML render mode. The default path is item.label',
                    },
                ],
            },
            {
                key: 'validation',
                components: [],
            },
            {
                key: 'api',
                components: [],
            },
            {
                key: 'conditional',
                components: [],
            },
            {
                key: 'logic',
                components: [],
            },
        ],
        ...extend,
    )

export default omitFormioTabs(selectBaseEditForm, omitTabsBaseConfig.customComp)
